import {buildGameResults} from "./buildGameResults";
import {getGameResultsPlaces} from "./compareGameResults";

/**
 * Промежуточные итоги раунда: места считаются так же, как в итогах партии
 * (buildGameResults), а монеты и очки фиксируются на момент конца раунда —
 * пока модалка итогов открыта, соперники в сетевой игре уже тратят монеты
 * нового раунда
 *
 * @returns {Array<{id: string, coins: number, winPoints: number, finalWinPoints: number, place: number}>}
 * по месту, первый — лидер; place — реальное место (у полной ничьей общее)
 */
export function buildRoundStandings(gameState) {
  const players = gameState.players || [];
  const playersById = new Map(players.map((player) => [player.id, player]));
  const results = buildGameResults(players, gameState.citiesCache || {});
  const places = getGameResultsPlaces(results);
  return results.map((result, index) => ({
    id: result.id,
    coins: playersById.get(result.id).coins,
    winPoints: playersById.get(result.id).winPoints,
    finalWinPoints: result.finalWinPoints,
    place: places[index],
  }));
}
